var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[(_vm.isNewLetter == true)?_c('h3',{attrs:{"id":'jump_' + _vm.letter}},[_vm._v(" "+_vm._s(_vm.letter))]):_vm._e(),_c('item-link',{attrs:{"item":_vm.item,"id":_vm.item.id}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }